import axios from 'axios';
import {
  IAccountShortCollection,
  IAddressShortCollection,
  ISubdivisionsShortCollection,
  IUserShortCollection,
} from 'common/models';
import {
  IGroupedByDeliveryDateSupplyListCollectionDto,
  IGroupedSupplyListPayload,
  ISupply,
  IChangeSupplyStatusPayload,
  ISupplyCollection,
  ICreateSupplyPayload,
  ISupplyListPayload,
  ISplitSupplyPayload,
  IUpdateSupplyDeliveryDatePayload,
  IUpdateSupplyPayload,
} from 'entities/Supply/Supply.models';

const basePath = 'supply';

export const supplyTransport = {
  get: (payload: ISupplyListPayload): Promise<ISupplyCollection> => axios.post(`${basePath}/list`, payload),
  getById: (id: number): Promise<ISupply> => axios.get(`${basePath}/${id}`),
  create: (payload: ICreateSupplyPayload): Promise<ISupplyCollection> => axios.post(`${basePath}`, payload),
  update: (payload: IUpdateSupplyPayload): Promise<ISupply> => axios.patch(`${basePath}`, payload),
  split: (payload: ISplitSupplyPayload): Promise<ISupplyCollection> => axios.post(`${basePath}/split`, payload),
  changeStatus: (payload: IChangeSupplyStatusPayload): Promise<ISupplyCollection> =>
    axios.post(`${basePath}/change-status`, payload),
  updateDeliveryDate: (payload: IUpdateSupplyDeliveryDatePayload): Promise<ISupplyCollection> =>
    axios.patch(`${basePath}/set-date`, payload),
  getBuyers: (payload: ISupplyListPayload): Promise<IAccountShortCollection> => axios.post(`${basePath}/buyers`, payload),
  getSubdivisions: (payload: ISupplyListPayload): Promise<ISubdivisionsShortCollection> =>
    axios.post(`${basePath}/subdivisions`, payload),
  getUsers: (payload: ISupplyListPayload): Promise<IUserShortCollection> => axios.post(`${basePath}/users`, payload),
  getAddresses: (payload: ISupplyListPayload): Promise<IAddressShortCollection> => axios.post(`${basePath}/addresses`, payload),
  getGroupedList: (payload: IGroupedSupplyListPayload): Promise<IGroupedByDeliveryDateSupplyListCollectionDto> =>
    axios.post(`${basePath}/grouped/by-delivery-date`, payload),
};
